// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.user.LeasingUserOuidWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingUserOuidWebApiHandler_getInfoForUser,
  LeasingUserOuidWebApiHandler_getInfoForUser_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetInfoForObfuscatedUserWebApiResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetInfoForUserParams {
  ouid: string;
}

export type LeasingUserOuidWebApiHandler_getInfoForUser_Options = UseQueryOptions<
  GetInfoForObfuscatedUserWebApiResponseDto,
  unknown,
  GetInfoForObfuscatedUserWebApiResponseDto,
  readonly [string, GetInfoForUserParams]
>;

const LeasingUserOuidWebApiHandler_getInfoForUser_GetKey = (getParams: GetInfoForUserParams) =>
  [LeasingUserOuidWebApiHandler_getInfoForUser_Path, getParams] as const;

export const LeasingUserOuidWebApiHandler_getInfoForUser_queryOptions = (
  getParams: GetInfoForUserParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserOuidWebApiHandler_getInfoForUser_GetKey(getParams),
    queryFn: () => LeasingUserOuidWebApiHandler_getInfoForUser(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease and user info for obfuscated user string
 */
export const useLeasingUserOuidWebApiHandler_getInfoForUser = (
  getParams: GetInfoForUserParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserOuidWebApiHandler_getInfoForUser_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeasingUserOuidWebApiHandler_getInfoForUser_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserOuidWebApiHandler_getInfoForUser.getKey = LeasingUserOuidWebApiHandler_getInfoForUser_GetKey;
